/**
 * Environment-driven config. Values are baked into the bundle at build time
 * by Vite via `import.meta.env.VITE_*`. Production values live in the
 * Cloudflare Pages dashboard (per-environment); local development reads
 * from `.env.local` (gitignored).
 */

function required(name: string, value: string | undefined): string {
  if (!value) {
    throw new Error(
      `Missing required env var ${name}. Set it in apps/web/.env.local for local dev or in the Cloudflare Pages project settings for deploys.`,
    );
  }
  return value;
}

export const config = {
  clerkPublishableKey: required("VITE_CLERK_PUBLISHABLE_KEY", import.meta.env.VITE_CLERK_PUBLISHABLE_KEY),
  apiBaseUrl: required("VITE_API_BASE_URL", import.meta.env.VITE_API_BASE_URL),
};
